export class TimeLookup {
 
  hours: number;
  minutes: number;
  symbol: string;
  fullTimeString: string;
  hours24: number;
  fullTimeString24: string;

 
  constructor(hoursVal: number, minutesVal: number, symbolVal: string) {
    this.hours = hoursVal;
    this.minutes = minutesVal;
    this.symbol = symbolVal;

    this.fullTimeString = this.hours.toString() + ':' + this.formatMinutes(minutesVal) + ' ' + this.symbol;
    this.hours24 = (this.symbol == 'AM' || this.hours == 12) ? this.hours : (this.hours + 12);
    this.fullTimeString24 = this.hours24.toString() + ':' + this.formatMinutes(minutesVal);
    
  }

  public formatMinutes(minutesVal: number): string {
    if (!isNaN(minutesVal) && minutesVal >= 0 && minutesVal < 10)
      return "0" + minutesVal.toString();
    else
      return minutesVal.toString();
  }
}



// WEBPACK FOOTER //
// ./src/app/core/models/time-lookup.ts